var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.25C4.84609 0.25 3.09375 2.07244 3.09375 4.3125V5.9375H2.3125C1.45078 5.9375 0.75 6.66631 0.75 7.5625V14.875C0.75 15.7712 1.45078 16.5 2.3125 16.5H11.6875C12.5492 16.5 13.25 15.7712 13.25 14.875V7.5625C13.25 6.66631 12.5492 5.9375 11.6875 5.9375H10.9062V4.3125C10.9062 2.07244 9.15391 0.25 7 0.25ZM4.65625 4.3125C4.65625 2.96863 5.70781 1.875 7 1.875C8.29219 1.875 9.34375 2.96863 9.34375 4.3125V5.9375H4.65625V4.3125ZM11.6891 14.875H7.78125V13.0241C8.24609 12.7422 8.5625 12.2238 8.5625 11.625C8.5625 10.7288 7.86172 10 7 10C6.13828 10 5.4375 10.7288 5.4375 11.625C5.4375 12.223 5.75391 12.7422 6.21875 13.0241V14.875H2.3125V7.5625H11.6875L11.6891 14.875Z",
    fill: "#BAC1DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.fb8ada02ab96c79f3babdfa4cc260506.svg";
export { ForwardRef as ReactComponent };